import { makeStyles } from '@mui/styles';

const useStyles = makeStyles(() => ({
  Box: {
    display: 'flex',
    gap: '16px',
    padding: '12px 24px 16px 24px',
    justifyContent: 'space-between',
    alignItems: 'center',
    alignSelf: 'stretch',
    borderTop: '1px solid var(--Gray-200, #EAECF0)',
  },
  BoxPage: {
    display: 'flex',
    alignItems: 'flex-start',
    gap: '2px',
  },
  PageNumbers: {
    display: 'flex',
    gap: '2px',
  },
}));

const buttonStyle = {
  width: 'max-content',
  display: 'flex',
  padding: '8px 14px',
  justifyContent: 'center',
  alignItems: 'center',
  gap: '8px',
  borderRadius: '8px',
  background: 'var(--Base-White, #FFF)',
  boxShadow: '0px 1px 2px 0px rgba(16, 24, 40, 0.05)',
  '&:hover': { backgroundColor: 'var(--Base-White, #FFF)' },
};

const buttonPage = {
  display: 'flex',
  width: '40px',
  padding: '12px',
  justifyContent: 'center',
  alignItems: 'center',
  flexShrink: 0,
  alignSelf: 'stretch',
  borderRadius: '8px',
  '&:hover': { backgroundColor: 'var(--Base-White, #FFF)' },
};

export { buttonPage, buttonStyle, useStyles };

